module.exports = "<div class=\"col s12 m6\"> <card class=\"blue-grey darken-1\"> <card-content> <card-title class=red-text>Card Title</card-title> <p class=white-text>I am a very simple card. I am good at containing small bits of information. I am convenient because I require little markup to use effectively.</p> </card-content> <card-action> <a href=#!>This is a link</a> <a href=#!>This is a link</a> </card-action> </card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/cards/basic-card.vue
 ** module id = 180
 ** module chunks = 0
 **/